"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lightbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/media-has-caption */
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Fade_1 = __importDefault(require("@material-ui/core/Fade"));
var GetApp_1 = __importDefault(require("@material-ui/icons/GetApp"));
var ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var ThumbnailTile_1 = require("../ThumbnailTile");
var VideoPreviewTile_1 = require("../VideoPreviewTile");
var useDownload_1 = require("../../hooks/useDownload");
var styles_1 = __importDefault(require("./styles"));
exports.Lightbox = react_1.default.memo(function (_a) {
    var open = _a.open, _b = _a.startingSlide, startingSlide = _b === void 0 ? 0 : _b, _c = _a.slides, slides = _c === void 0 ? [] : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.onClose, onClose = _e === void 0 ? function () { } : _e;
    var classes = (0, styles_1.default)();
    var download = (0, useDownload_1.useDownload)().download;
    var _f = (0, react_1.useState)(startingSlide), currentSlide = _f[0], setCurrentSlide = _f[1];
    var allowPrev = currentSlide > 0;
    var allowNext = currentSlide < slides.length - 1;
    var handleClose = function (event) {
        onClose(event);
    };
    var handleDownload = function () {
        download({
            href: slides[currentSlide].downloadSrc,
            filename: slides[currentSlide].name,
        });
    };
    var handleNext = function () {
        if (currentSlide < slides.length) {
            setCurrentSlide(function (prev) { return prev + 1; });
        }
    };
    var handlePrev = function () {
        if (currentSlide > 0) {
            setCurrentSlide(function (prev) { return prev - 1; });
        }
    };
    return open ? ((0, jsx_runtime_1.jsx)(Fade_1.default, __assign({ in: open }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ className: classes.root, role: "presentation" }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ className: classes.toolbar }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, __assign({ id: "LightboxDownloadButton", color: "inherit", "data-testid": "download-button", onClick: function () { return handleDownload(); } }, { children: (0, jsx_runtime_1.jsx)(GetApp_1.default, { fontSize: "large" }) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, __assign({ id: "LightboxCloseButton", color: "inherit", "data-testid": "close-button", onClick: handleClose }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, { fontSize: "large" }) }))] })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ className: classes.slideWrapper }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ className: classes.slideControl }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, __assign({ id: "LightboxPrevButton", color: "inherit", "data-testid": "previous-button", disabled: !allowPrev, onClick: function () { return handlePrev(); } }, { children: (0, jsx_runtime_1.jsx)(ChevronLeft_1.default, { fontSize: "inherit" }) })) })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ className: classes.slides }, { children: slides.map(function (slide, index) {
                                    return !slide.video ? (
                                    // TODO: improve this with lazy loading
                                    (0, jsx_runtime_1.jsx)(ThumbnailTile_1.ThumbnailTile, { onClick: function (evt) { return onClick(evt, { currentSlide: currentSlide }); }, hidden: currentSlide !== index, idPrefix: "LighboxImageSlide".concat(index), src: slide.displaySrc, name: slide.name }, slide.displaySrc)) : (currentSlide === index && ((0, jsx_runtime_1.jsx)(VideoPreviewTile_1.VideoPreviewTile, { idPrefix: "LighboxVideoSlide".concat(index), src: slide.displaySrc, name: slide.name }, slide.displaySrc)));
                                }) })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ className: classes.slideControl }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, __assign({ id: "LightboxNextButton", "data-testid": "next-button", color: "inherit", disabled: !allowNext, onClick: function () { return handleNext(); } }, { children: (0, jsx_runtime_1.jsx)(ChevronRight_1.default, { fontSize: "inherit" }) })) }))] })), (0, jsx_runtime_1.jsx)(Box_1.default, { className: classes.thumbs })] })) })) }))) : null;
});
